import { privateRequest, type ApiResponse } from "../axios";
import type { CustomField } from "./customField";

const ENDPOINTS = {
    OPPORTUNITY_CONFIGURATION_FIELDS: "api/OpportunityConfigurationFields",
    OPPORTUNITY_CONFIGURATION_CUSTOM_FIELDS: "api/OpportunityConfigurationCustomFields",
    OPPORTUNITY_CUSTOM_FIELD: "api/OpportunityCustomFields",
};

const fetchOpportunityConfigurationFields = async (): Promise<ApiResponse<any>> => {
    const res = await privateRequest.get(ENDPOINTS.OPPORTUNITY_CONFIGURATION_FIELDS);
    return res.data;
};

const getOpportunityConfigurationCustomField = async (): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get(ENDPOINTS.OPPORTUNITY_CONFIGURATION_CUSTOM_FIELDS);
    return response.data;
};

const updateOpportunityConfigurationCustomFields = async (payload: any): Promise<ApiResponse<any>> => {
    const res = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.OPPORTUNITY_CONFIGURATION_CUSTOM_FIELDS, payload);
    return res.data;
};

const deleteOpportunityConfigurationCustomFields = async (data: any): Promise<ApiResponse<any>> => {
    const response = await privateRequest.delete<ApiResponse<any>>(`${ENDPOINTS.OPPORTUNITY_CONFIGURATION_CUSTOM_FIELDS}/${data.Id}`);
    return response.data;
};

const getOpportunityCustomFields = async (): Promise<ApiResponse<CustomField[]>> => {
    const response = await privateRequest.get<ApiResponse<CustomField[]>>(ENDPOINTS.OPPORTUNITY_CUSTOM_FIELD);
    return response.data;
};

const deleteOpportunityCustomField = async (data: any): Promise<ApiResponse<CustomField>> => {
    const response = await privateRequest.delete<ApiResponse<CustomField>>(`${ENDPOINTS.OPPORTUNITY_CUSTOM_FIELD}/${data.Id}?customType=${data.CustomType}`);
    return response.data;
};

const updateOpportunityCustomField = async (data: CustomField): Promise<ApiResponse<CustomField>> => {
    const response = await privateRequest.put<ApiResponse<CustomField>>(ENDPOINTS.OPPORTUNITY_CUSTOM_FIELD, data);
    return response.data;
};

const addOpportunityCustomField = async (data: CustomField): Promise<ApiResponse<CustomField>> => {
    const response = await privateRequest.post<ApiResponse<CustomField>>(ENDPOINTS.OPPORTUNITY_CUSTOM_FIELD, data);
    return response.data;
};

const opportunityConfigurationService = {
    fetchOpportunityConfigurationFields,
    getOpportunityConfigurationCustomField,
    updateOpportunityConfigurationCustomFields,
    deleteOpportunityConfigurationCustomFields,
    getOpportunityCustomFields,
    addOpportunityCustomField,
    updateOpportunityCustomField,
    deleteOpportunityCustomField,
};

export default opportunityConfigurationService;